import React from 'react';
import { ModalProps } from '@/Types';
import { CreateDocumentModal } from './modules/CreateDocumentModal/CreateDocumentModal';
import { SelectDocumentModal } from './modules/SelectDocumentModal/SelectDocumentModal';
import { SelectTemplateModal } from './modules/SelectTemplateModal/SelectTemplateModal';
import { SingleDocumentPrintModal } from './modules/SingleDocumentPrintModal/SingleDocumentPrintModal';
import { TemplateNotExists } from './modules/TemplateNotExistsModal/TemplateNotExistsModal';
import { documentPrintModalActions, DocumentPrintStep } from './services/reducer';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';
import { useDocumentPrintModalOptions } from './hooks/useDocumentPrintModalOptions';

export function DocumentPrintModal({ closeModalWindow }: ModalProps) {
  const dispatch: AppDispatch = useDispatch();

  const { currentStep } = useDocumentPrintModalOptions();

  const onCloseModal = () => {
    dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.Close));
  };

  switch (currentStep) {
    case DocumentPrintStep.TemplateNotExists:
      return <TemplateNotExists onClose={onCloseModal} />;

    case DocumentPrintStep.SingleDocumentPrint:
      return <SingleDocumentPrintModal onClose={onCloseModal} />;

    case DocumentPrintStep.SelectTemplate:
      return <SelectTemplateModal onClose={onCloseModal} />;

    case DocumentPrintStep.CreateDocument:
      return <CreateDocumentModal onClose={onCloseModal} />;

    case DocumentPrintStep.SelectDocumentNumber:
      return <SelectDocumentModal onClose={onCloseModal} />;

    case DocumentPrintStep.None:
      return null;

    case DocumentPrintStep.Close:
    default:
      closeModalWindow();
      return null;
  }
}
